import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import { ThemeProvider } from '@/context/theme';
import { queryClient } from '@/lib/query-client';
import { App } from './App';
import './index.css';

// Provider nesting (RFC-0009 §2 app-shell mount contract):
//   QueryClientProvider (outermost — owns the read cache, ADR-0007)
//     → ThemeProvider (unchanged) → BrowserRouter → App
// AuthProvider is intentionally NOT mounted here; it mounts inside the
// authenticated AppShell subtree in Phase 2 (RFC-0009 B4), so /login never
// fires a protected query.
ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </ThemeProvider>
    </QueryClientProvider>
  </React.StrictMode>,
);
